import { useState } from "react";
import { Sparkles, Send, Mic, Camera, ChevronRight } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export const AiStrip = () => {
  const [q, setQ] = useState("");
  const open = (detail = {}) => {
    window.dispatchEvent(new CustomEvent("open-ai-chat", { detail }));
    setQ("");
  };
  return (
    <div data-testid="ai-strip" className="flex items-center gap-2 rounded-xl border border-indigo-500/40 bg-gradient-to-r from-indigo-500/10 to-violet-500/10 px-3 py-2.5">
      <div className="h-9 w-9 rounded-lg bg-indigo-600 flex items-center justify-center shrink-0">
        <Sparkles className="h-4 w-4 text-white" />
      </div>
      <span className="font-bold text-sm hidden sm:inline" style={{ fontFamily: "Outfit, sans-serif" }}>Ask AI</span>
      <Button data-testid="ai-strip-camera" size="sm" variant="ghost" onClick={() => open({ mode: "camera" })}
        className="h-9 w-9 p-0 rounded-full text-slate-400 hover:text-white hover:bg-slate-800 shrink-0" title="Photo">
        <Camera className="h-4 w-4" />
      </Button>
      <Button data-testid="ai-strip-mic" size="sm" variant="ghost" onClick={() => open({ mode: "mic" })}
        className="h-9 w-9 p-0 rounded-full text-slate-400 hover:text-white hover:bg-slate-800 shrink-0" title="Speak">
        <Mic className="h-4 w-4" />
      </Button>
      <Input data-testid="ai-strip-input" placeholder='"JH27 ka rate?" · "Aaj kya bechein?"' value={q} onChange={(e) => setQ(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && q.trim() && open({ message: q.trim() })}
        className="bg-[#0B0F17] border-[#334155] text-slate-100 placeholder:text-slate-500 h-9 rounded-full text-xs flex-1" />
      <Button data-testid="ai-strip-send" size="sm" onClick={() => q.trim() ? open({ message: q.trim() }) : open()}
        className="h-9 w-9 p-0 rounded-full bg-indigo-600 hover:bg-indigo-500 text-white shrink-0">
        <Send className="h-4 w-4" />
      </Button>
      <button data-testid="ai-strip-expand" onClick={() => open()} className="hidden sm:flex items-center text-[11px] text-indigo-400 hover:text-indigo-300 shrink-0">
        Expand <ChevronRight className="h-3 w-3" />
      </button>
    </div>
  );
};
